import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Mac OS X Lion and Wi-Fi",
  "description": "",
  "published": "2011-09-18T00:00:00.000Z",
  "redirect_from": ["/blog/mac-os-x-lion-and-wi-fi/swizec/2464"],
  "categories": "Apple, IPad, IPhone, Learning, Mac OS, Mac OS X Lion, Operating system, Personal, Snow Leopard, Steve Jobs",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/09/300px-WPA_road_project2.gif",
        "alt": "Works Progress Administration road project. (5...",
        "title": "Works Progress Administration road project. (5..."
      }}></img></p>
    <p>{`Upon getting back from the US in late August I noticed that my laptop suddenly doesn't want to connect to my home wireless network. At the time I didn't really give it much thought because everything else from `}<a parentName="p" {...{
        "href": "http://www.apple.com/ipad/",
        "title": "iPad"
      }}>{`the iPad`}</a>{` to the `}<a parentName="p" {...{
        "href": "http://www.apple.com/iphone",
        "title": "iPhone"
      }}>{`iPhone`}</a>{` to all the other laptops at home connected just fine and since I have a desktop computer as well there wasn't really much need to fuss.`}</p>
    <p>{`A couple of weeks later I realized that turning off security on my network allows the Mac Laptop to connect just fine ... ok, I thought, so it must be due to something with the security settings. I'm guessing `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Works_Progress_Administration",
        "title": "Works Progress Administration"
      }}>{`WPA`}</a>{` just doesn't cut it anymore and Apple is doing their thing and pushing everyone forward. Just like they were the first to stop with floppy and CD drives on some computers.`}</p>
    <p>{`I'll just buy a new router that supports WPA2 then, more security never really hurt anyone.`}</p>
    <p>{`Again, I had enough other devices that connected just fine and didn't feel like fussing about it. Plus by this time I had discovered a neighbour's wi-fi for the most important of internet things.`}</p>
    <p>{`Eventually I got so used to the neighbour's wifi I started using `}<a parentName="p" {...{
        "href": "http://www.spotify.com/",
        "title": "Spotify"
      }}>{`Spotify`}</a>{` and some other things that need quite a bit of oomph.`}</p>
    <p>{`Then two days ago the builders working on the facade of my building put up scaffolding outside my room and suddenly that friendly neighbour's wifi didn't work anymore!`}</p>
    <p>{`At least not that well!`}</p>
    <p>{`Therefore I was forced to fix the issue immediately and discovered that there is a very freaking weird bug in `}<a parentName="p" {...{
        "href": "http://www.apple.com/macosx/lion",
        "title": "Mac OS X Lion"
      }}>{`Mac OS X Lion`}</a>{`.`}</p>
    <p>{`Apparently when you upgrade from `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Snow_Leopard",
        "title": "Snow Leopard"
      }}>{`Snow Leopard`}</a>{` to Lion sometimes (all the time?) your keychain will get screwed up. This means you suddenly lose connectivity to all networks that require login and you have previously used!`}</p>
    <p>{`The fix is "simple":`}</p>
    <ol>
      <li parentName="ol">{`Remove all networks from networks list`}</li>
      <li parentName="ol">{`Open Keychain and remove all Airport passwords from System`}</li>
      <li parentName="ol">{`Reboot`}</li>
      <li parentName="ol">{`Voila, connectivity!`}</li>
    </ol>
    <p>{`If this is the sign of things to come as `}<a parentName="p" {...{
        "href": "http://www.crunchbase.com/person/steve-jobs",
        "title": "Steve Jobs"
      }}>{`Steve Jobs`}</a>{` moves away from Apple I don't think I'm going to like using these products much longer ...`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=ab1bde25-40d9-4f5b-b991-76e6f6f18771",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      